'use client';

import type { Metadata } from 'next';
import { useState } from 'react';

// В client-компоненте export const metadata не работает —
// метаданные для этой страницы задаются через layout или убрать вовсе.
export default function ContactsPage() {
  const [sent, setSent] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSent(true);
    // TODO: отправка на сервер / в CRM / на почту
  }

  return (
    <section className="section">
      <div className="container">
        <h2>Контакты</h2>
        <p className="lead">
          Тел.: +7 (4912) 00-00-00 · info@example.ru · г. Рязань, ул. Примерная, 1
        </p>

        <form className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">Имя</label>
          <input id="name" name="name" required />

          <label htmlFor="phone">Телефон</label>
          <input id="phone" name="phone" type="tel" required />

          <label htmlFor="message">Сообщение</label>
          <textarea id="message" name="message" />

          <p>
            <button type="submit" className="btn" style={{ marginTop: 16 }}>
              Отправить заявку
            </button>
          </p>
          {sent && <p className="form-msg">Заявка отправлена — мы свяжемся с вами.</p>}
        </form>
      </div>
    </section>
  );
}
